import FacebookIconSvg from '../../../../img/logos/facebook.svg';
import { createSVGComponentFromSVG } from './create-svg-components-from-svg';

export const FacebookIcon = createSVGComponentFromSVG(
    FacebookIconSvg,
    'FacebookIcon',
);
